/*
Shared utilities for YouTube video handling across components
Extracted from VehicleVideoEnhanced for reuse in PublicationFormManager
Autor: Assistant
Fecha: June 23, 2025
*/

export const isValidYouTubeUrl = (url: string): boolean => {
  return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/i.test(url)
}

export const extractYouTubeId = (url: string): string | null => {
  const regExp = /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
  const match = url.match(regExp)

  return match && match[1].length === 11 ? match[1] : null
}
